import DataObjectMap from 'assets/components/dataObjectMap/DataObjectMap';
import { useModalForm } from 'assets/components/form/modalForm/ModalForm';
import FormatValue from 'assets/components/formatValue/FormatValue';
import Icon from 'assets/components/icon/Icon';
import NumberInput from 'assets/components/inputs/number/NumberInput';
import FormWrapper from 'assets/components/inputs/wrappers/FormWrapper';
import InputWrapper from 'assets/components/inputs/wrappers/InputWrapper';
import ThemeTableSimple from 'assets/components/table/themes/Theme.Table.Simple';
import { getLocales } from 'assets/locales/Locale';
import { useAuthStore } from 'assets/providers/authStore/Provider.AuthStore';
import Theme from 'assets/themes/Theme.Common';
import { useSalesContractProvider } from '../../../Sales.Contract.Hooks';
import { ContractAdjustForm } from '../Contract.AdjustDistributions';
import { useEffect } from 'react';
import { sumAllDistributions } from 'app/scripts/PricingHelper';

const ContractAdjustDistributionsDistributions = () => {
  const { lang } = getLocales();
  const { form } = useModalForm<ContractAdjustForm>();
  const { selected } = useSalesContractProvider();
  const { isDealer } = useAuthStore();

  /* TODO: Add if needed.
  function sumAll(distributions?: Utils.PricingDistribution) {
    return values(distributions).reduce((p, c) => p + c.amount, 0) ?? 0;
  }
  const isSameSum =
    sumAll(form.data.pricingDistributions) === sumAll(selected?.pricingDistributions) &&
    sumAll(form.data.distributorDistributions) === sumAll(selected?.distributorDistributions);
 */

  useEffect(() => {
    const { originalPriceCAD, distributorPriceCAD } = selected ?? {};

    const pricingDistributionsSum = sumAllDistributions(form.data.pricingDistributions);
    const distributorDistributionsSum = sumAllDistributions(form.data.distributorDistributions);

    const newDiscountPriceCAD =
      pricingDistributionsSum - originalPriceCAD + (distributorDistributionsSum - distributorPriceCAD);

    form.update({
      discountPriceCAD: newDiscountPriceCAD,
      priceCAD: originalPriceCAD + distributorPriceCAD + newDiscountPriceCAD,
    });
  }, [form.data.pricingDistributions, form.data.distributorDistributions]);

  return (
    <FormWrapper>
      {/* TODO: Add if needed.
        !isSameSum && (
          <p
            style={{
              backgroundColor: Theme.Color.error,
              color: 'white',
              padding: `${Theme.Size.M} ${Theme.Size.L}`,
              fontWeight: 'bold',
            }}
          >
            Sum of changed prices need to match original sum!
          </p>
        )
        */}
      <p
        style={{
          backgroundColor: Theme.Color.warning,
          color: 'white',
          padding: `${Theme.Size.M} ${Theme.Size.L}`,
          fontWeight: 'bold',
          marginTop: 0,
        }}
      >
        {lang.contractUnrestrictedUpdateWarningMessage}
      </p>
      <InputWrapper>
        <NumberInput
          name="originalPriceCAD"
          value={form.data.originalPriceCAD}
          label={lang.basePrice}
          onChange={form.update}
          icon={<Icon class={'fas-dollar-sign'} />}
          min={0}
          step={0.01}
          roundOnBlur
          readOnly
        />
        <NumberInput
          name="distributorPriceCAD"
          value={form.data.distributorPriceCAD}
          label={lang.distributorPrice}
          onChange={form.update}
          icon={<Icon class={'fas-dollar-sign'} />}
          min={0}
          step={0.01}
          roundOnBlur
          readOnly
        />
        <NumberInput
          name="discountPriceCAD"
          value={form.data.discountPriceCAD}
          label={lang.adjustedPrice}
          onChange={form.update}
          icon={<Icon class={'fas-dollar-sign'} />}
          min={0}
          step={0.01}
          roundOnBlur
          readOnly
        />
        <NumberInput
          name="priceCAD"
          value={form.data.priceCAD}
          label={lang.price}
          onChange={form.update}
          icon={<Icon class={'fas-dollar-sign'} />}
          min={0}
          step={0.01}
          roundOnBlur
          readOnly
        />
      </InputWrapper>
      <NumberInput
        name="salePriceCAD"
        value={form.data.salePriceCAD}
        label={lang.salePrice}
        onChange={form.update}
        icon={<Icon class={'fas-dollar-sign'} />}
        min={0}
        step={0.01}
        roundOnBlur
      />
      <InputWrapper>
        <NumberInput
          name="dealerCostGstHst"
          value={Number(((form.data.dealerCostGstHst || 0) * 100).toFixed(2))}
          label={lang.dealerCostGstHst}
          onChange={({ dealerCostGstHst }) =>
            form.update({
              dealerCostGstHst: dealerCostGstHst * 0.01,
            })
          }
          icon={<Icon class={'fas-percentage'} />}
          step={0.01}
          roundOnBlur
        />
        <NumberInput
          name="dealerCostProvincialSalesTax"
          value={Number(((form.data.dealerCostProvincialSalesTax || 0) * 100).toFixed(2))}
          label={lang.dealerCostPst}
          onChange={({ dealerCostProvincialSalesTax }) =>
            form.update({
              dealerCostProvincialSalesTax: dealerCostProvincialSalesTax * 0.01,
            })
          }
          icon={<Icon class={'fas-percentage'} />}
          step={0.01}
          roundOnBlur
        />
      </InputWrapper>
      <InputWrapper>
        <NumberInput
          name="dealerRemittanceGstHst"
          value={Number(((form.data.dealerRemittanceGstHst || 0) * 100).toFixed(2))}
          label={lang.dealerRemittanceGstHst}
          onChange={({ dealerRemittanceGstHst }) =>
            form.update({
              dealerRemittanceGstHst: dealerRemittanceGstHst * 0.01,
            })
          }
          icon={<Icon class={'fas-percentage'} />}
          step={0.01}
          roundOnBlur
        />
        <NumberInput
          name="dealerRemittanceProvincialSalesTax"
          value={Number(((form.data.dealerRemittanceProvincialSalesTax || 0) * 100).toFixed(2))}
          label={lang.dealerRemittancePst}
          onChange={({ dealerRemittanceProvincialSalesTax }) =>
            form.update({
              dealerRemittanceProvincialSalesTax: dealerRemittanceProvincialSalesTax * 0.01,
            })
          }
          icon={<Icon class={'fas-percentage'} />}
          step={0.01}
          roundOnBlur
        />
      </InputWrapper>
      <InputWrapper>
        <NumberInput
          name="dealerProfitGstHst"
          value={Number(((form.data.dealerProfitGstHst || 0) * 100).toFixed(2))}
          label={lang.dealerProfitGstHst}
          onChange={({ dealerProfitGstHst }) =>
            form.update({
              dealerProfitGstHst: dealerProfitGstHst * 0.01,
            })
          }
          icon={<Icon class={'fas-percentage'} />}
          step={0.01}
          roundOnBlur
        />
        <NumberInput
          name="dealerProfitProvincialSalesTax"
          value={Number(((form.data.dealerProfitProvincialSalesTax || 0) * 100).toFixed(2))}
          label={lang.dealerProfitPst}
          onChange={({ dealerProfitProvincialSalesTax }) =>
            form.update({
              dealerProfitProvincialSalesTax: dealerProfitProvincialSalesTax * 0.01,
            })
          }
          icon={<Icon class={'fas-percentage'} />}
          step={0.01}
          roundOnBlur
        />
      </InputWrapper>
      <table className={ThemeTableSimple}>
        <thead>
          <tr>
            <th>{lang.pricingDistributions}</th>
            <th>{lang.originalPrice}</th>
            <th>{lang.adjustedPrice}</th>
          </tr>
        </thead>
        <tbody>
          <DataObjectMap
            data={form.data.pricingDistributions}
            render={({ data: pricingInfo, key }) => {
              const old = selected.pricingDistributions[key];
              return (
                <tr key={key}>
                  <td>{key}</td>
                  <td>
                    <FormatValue value={`${(old?.amount ?? 0).toFixed(2)}$`} />
                  </td>
                  <td>
                    <NumberInput
                      name="amount"
                      value={pricingInfo.amount}
                      onChange={({ amount }) =>
                        form.update({
                          pricingDistributions: {
                            ...form.data.pricingDistributions,
                            [key]: {
                              ...pricingInfo,
                              amount,
                            },
                          },
                        })
                      }
                      style={{
                        formInput: {
                          minWidth: '157px',
                        },
                        input: {
                          textAlign: 'right',
                        },
                      }}
                      icon={<Icon class={'fas-dollar-sign'} />}
                      min={0}
                      step={0.01}
                      roundOnBlur
                    />
                  </td>
                </tr>
              );
            }}
          />
        </tbody>
        {!isDealer && (
          <>
            <thead>
              <tr>
                <th>{lang.distributorDistributions}</th>
                <th>{lang.originalPrice}</th>
                <th>{lang.adjustedPrice}</th>
              </tr>
            </thead>
            <tbody>
              <DataObjectMap
                data={form.data.distributorDistributions}
                render={({ data: pricingInfo, key }) => {
                  const old = selected.distributorDistributions[key];
                  return (
                    <tr key={key}>
                      <td>{key}</td>
                      <td>
                        <FormatValue value={`${(old?.amount ?? 0).toFixed(2)}$`} />
                      </td>
                      <td>
                        <NumberInput
                          name="amount"
                          value={pricingInfo.amount}
                          onChange={({ amount }) =>
                            form.update({
                              distributorDistributions: {
                                ...form.data.distributorDistributions,
                                [key]: {
                                  ...pricingInfo,
                                  amount,
                                },
                              },
                            })
                          }
                          style={{
                            formInput: {
                              minWidth: '157px',
                            },
                            input: {
                              textAlign: 'right',
                            },
                          }}
                          icon={<Icon class={'fas-dollar-sign'} />}
                          min={0}
                          step={0.01}
                          roundOnBlur
                        />
                      </td>
                    </tr>
                  );
                }}
              />
            </tbody>
          </>
        )}
      </table>
    </FormWrapper>
  );
};

export default ContractAdjustDistributionsDistributions;
